import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { TenderRegistrationVM } from '~src/types/db';
import { loadSharedTenderDetails } from '~src/services/api/shares';
import { QueryKeys } from './queryKeys';

interface useSharedTenderDetailsParams {
  id: string;
  shareKey?: string;
}
export const useSharedTenderDetails = (
  { id, shareKey }: useSharedTenderDetailsParams,
  queryConfig: QueryConfig<TenderRegistrationVM, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<TenderRegistrationVM, AxiosError>(
    [QueryKeys.sharedTenderDetails, { id, shareKey }],
    (_, params: useSharedTenderDetailsParams) =>
      loadSharedTenderDetails({
        id: params.id,
        shareKey: params.shareKey,
      }),
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
